import { useMailToAction } from '@components/button/MailToButton'
import { colors } from '@globals/themes/defaultTheme'
import { onHover } from '@globals/themes/themeConstants'
import EmailOutlined from '@mui/icons-material/EmailOutlined'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { T } from '@transifex/react'

type ContactSupportMenuItemProps = {
  onClose?: () => void
  iconColor?: string
  isMobile?: boolean
}
const ContactSupportMenuItem: React.FC<ContactSupportMenuItemProps> = ({
  onClose,
  iconColor,
  isMobile,
}) => {
  const { handleClick } = useMailToAction()

  return (
    <MenuItem
      onClick={() => {
        handleClick()
        onClose?.()
      }}
      disableRipple={isMobile}
      disableTouchRipple={isMobile}
      sx={
        isMobile
          ? {
              [onHover]: {
                backgroundColor: 'transparent',
              },
            }
          : undefined
      }>
      <Stack direction="row" spacing={1} alignItems="center">
        <EmailOutlined sx={{ color: iconColor ?? colors.grayPrimary }} />
        <Typography variant={isMobile ? 'h3' : 'inherit'} sx={{ mt: { xs: 0 } }}>
          <T _str="Contact support" />
        </Typography>
      </Stack>
    </MenuItem>
  )
}

export default ContactSupportMenuItem
